<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a href="/admin/notify/">Notifications</a></li>
      <li class="breadcrumb-item active" aria-current="page">Edit Notifications</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Notification</h2>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group required mt-1">
                <label class="control-label" for="type">Type</label>
                <input type="text" id="type" [(ngModel)]="editNotification.type"  maxlength="30" class="form-control"
                       (blur)="TypeStatusText()" [ngClass]="{'is-invalid':typeStatusText}" [ngModelOptions]="{standalone: true}" required>

                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!typeStatusText">{{typeStatusText}}</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div id="statusText" class="invalid-feedback d-block shift-invalid-text" [hidden]="!statusText">{{statusText}}</div>
          <h2 class="text-black mb-3">Reason</h2>
          <div class="row">
            <div class="col-md-5">
              <div class="required">
                <label for="description" class="control-label" style="font-size:11px">Message/Reason to specify</label>
                <textarea id="description" [(ngModel)]="editNotification.description" rows="6" class="form-control"
                          (blur)="DescStatusText()" [ngClass]="{'is-invalid':descStatusText}" maxlength="250" [ngModelOptions]="{standalone: true}" required></textarea>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!descStatusText">{{descStatusText}}</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
  <div class="col-12 text-right">
    <button type="submit" class="btn btn-cancel-prime" routerLink="/admin/notify">Cancel</button>
    <button type="submit" class="btn btn-orange-prime ml-2" (click)="submitUpdateNotify()">Submit</button>
  </div>
</div>
</div>
